import api from '../../api/api'
import * as types from '../mutation-types'
import * as conf from '../../config'
import _ from 'lodash'

const state = {
  all: [],
  loading: true,
  orderType: conf.SORT_BY_NEW,
  orderTypes: conf.SORT_TYPES
}

const getters = {
  sortedApps: state => {
    if (state.orderType === conf.SORT_BY_NEW) {
      return _.orderBy(state.all, 'publishedAt', 'desc')
    }
    if (state.orderType === conf.SORT_BY_DOWNLOAD) {
      return _.orderBy(state.all, 'recommendedOrder', 'asc')
    }
  }
}

const actions = {
  getAllApps ({ commit }) {
    commit(types.START_LOADING)

    Promise.all([api.getApps(), api.getDlApps()])
      .then(([res, dl]) => {
        const apps = []

        res.data.items.forEach(app => {
          const entryPoints = _createEntryPoints(app.application.platformEntryPoints)
          if (entryPoints.length === 0) return

          const indexAtDlApps = dl.data.apps.findIndex(dlApp => dlApp.id === app.application.id)

          apps.push({
            application: {
              name: app.application.name,
              id: app.application.id,
              images: app.application.images,
              messageBundles: {
                shortDescription: app.application.messageBundles.shortDescription
              }
            },
            entryPoints,
            publishedAt: _createPublishedAt(entryPoints),
            recommendedOrder: indexAtDlApps === -1 ? 9999 : indexAtDlApps
          })
        })

        commit(types.RECEIVE_APPS, apps)
        commit(types.STOP_LOADING)
      })
      .catch((err) => {
        commit(types.STOP_LOADING)
        console.error(`error: getApps ${err}`)
      })
  },
  changeOrderType ({ commit }, orderType) {
    commit(types.CHANGE_ORDER_TYPE, orderType)
  }
}

function _createEntryPoints (platformEntryPoints) {
  const entryList = []
  Object.keys(platformEntryPoints).forEach((key) => {
    if (Object.keys(platformEntryPoints[key]).length === 0) {
      return
    }
    if (platformEntryPoints[key].type !== 'EntryPoint') {
      return
    }
    if (!platformEntryPoints[key].states.visibility) {
      return
    }
    if (platformEntryPoints[key].states.closed) {
      return
    }
    if (platformEntryPoints[key].states.preRegister) {
      return
    }
    entryList.push({
      id: getId(key),
      publishedAt: platformEntryPoints[key].publishedAt
    })
  })

  return entryList

  function getId (key) {
    switch (key) {
      case 'AndApp_windows_x86':
      case 'AndApp_windows_x86_64':
      case 'AndApp_MobagePCShellApp_windows_x86':
      case 'AndApp_MobagePCShellApp_windows_x86_64':
        return 'win'
      case 'AndApp_mac_x86_64':
      case 'AndApp_MobagePCShellApp_mac_x86_64':
        return 'mac'
      case 'AndApp_web':
        return 'browser'
      case 'GooglePlay':
        return 'android'
      case 'AppStore':
        return 'ios'
      case 'Mobage':
        return 'mobage'
      case 'ChromeWebStore':
        return 'chromeApp'
      default:
        throw new Error('Error: Unknown EntryPoint')
    }
  }
}

function _createPublishedAt (entryPoints) {
  return Math.min.apply(null, entryPoints.map(e => {
    return e.publishedAt
  }))
}

const mutations = {
  [types.RECEIVE_APPS] (state, apps) {
    state.all = apps
  },
  [types.START_LOADING] (state) {
    state.loading = true
  },
  [types.STOP_LOADING] (state) {
    state.loading = false
  },
  [types.CHANGE_ORDER_TYPE] (state, orderType) {
    state.orderType = orderType
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
